/**
 * External Dependencies
 */

// https://discourse.roots.io/t/sage-10-and-js-routing/19020

import LazyLoad from 'vanilla-lazyload';
import CookieBar from './tools/cookie-bar';
import './tools/responsive';
import './helpers';
import WebUI from './components/WebUI';
import {Countup} from './components/Countup';
import {Tham} from './components/Tham';
import {SiteHeaderMenu} from './components/SiteHeader';
import GLightbox from 'glightbox';

// import { FilterMap } from './components/FilterMap';
import RealizationsMap from './components/RealizationsMap';
import SellersMap from './components/SellersMap';
import Selects from './components/Selects';
import {Footer} from './components/Footer';
// import { Filter } from './components/Filter';

var $ = require("jquery");

import Swiper from 'swiper';
import SwiperCore, {
  Thumbs,
  Autoplay,
  Pagination,
  HashNavigation,
} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Thumbs, Autoplay, Pagination, HashNavigation]);

import Alpine from 'alpinejs';
import { ThankYouPage } from './components/ThankYouPage';

$(document).ready(() => {
  $('.cd-upload-btn').html('Dołącz pliki <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="#F39911"></path></svg>');

  checkIfHashNavToProductTab();
});

function checkIfHashNavToProductTab() {
  let hash = window.location.hash;
  if (!hash) {
    return;
  }

  const anchorableSection = document.querySelector('[data-anocharable-section]');
  if (!anchorableSection) {
    return;
  }

  anchorableSection.scrollIntoView({});
}

document.addEventListener('DOMContentLoaded', function () {
  window.Alpine = Alpine;
  Alpine.start();

  // Lazyload
  let lazyLoad = new LazyLoad({
    elements_selector: '[data-lazy]',
    load_delay: 300,
  });

  // Cookiebar
  const _CookieBar = new CookieBar();
  _CookieBar.init();

  const _footer = new Footer();
  _footer.init();


  const _thankYouPage = new ThankYouPage();
  _thankYouPage.init();
  const _siteHeaderMenu = new SiteHeaderMenu();
  const _webUI = new WebUI();
  const _tham = new Tham();
  const _countsup = new Countup();

  const _realizationMap = new RealizationsMap();
  _realizationMap.init();

  const _sellersMap = new SellersMap();
  _sellersMap.init();

  _tham.subscribe((menuState) => {
    _webUI.documentBodyFreeze();
    _siteHeaderMenu.toogleMobileMenu(menuState);
  });

  _webUI.scrollSubscribe((scrollDepth, w, y) => {
    _countsup.onScroll(scrollDepth, w, y);
    _siteHeaderMenu.onScroll(scrollDepth);
  });

  _webUI.scrollDepth();

  _siteHeaderMenu.subscribe((menuClick) => {
    _tham.toogleThamState();
    _webUI.documentBodyFreeze(false);
  });
  // Home slider
  const hsNavSwiper = new Swiper('.hs__nav-swiper', {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });

  const hero_swiper = new Swiper('.hs__main-swiper', {
    loop: true,
    autoplay: {
      delay: 4000,
    },
    thumbs: {
      swiper: hsNavSwiper,
    },
    on: {
      init: function (swiper) {
        initDarkModeOnSlide(swiper);
      },
    },
  });

  function initDarkModeOnSlide(swiper) {
    let slides = swiper.slides;

    let currentSlide = slides[swiper.activeIndex] ?? null;
    if (!currentSlide) {
      return;
    }

    let dark_menu = currentSlide.dataset.menuDarkTheme;

    if (dark_menu == 1 || dark_menu == '1' || dark_menu == true || dark_menu == 'true') {
      _siteHeaderMenu.setDarkTheme();
      setNavigationTheme(true);
    } else {
      _siteHeaderMenu.removeDarkTheme();
      setNavigationTheme(false);
    }
  }

  hero_swiper.emit('init');

  hero_swiper.on('activeIndexChange', function (swiper) {
    let slides = swiper.slides;
    let currentSlide = slides[swiper.activeIndex] ?? null;

    if (!currentSlide) {
     return;
    }

    let dark_menu = currentSlide.dataset.menuDarkTheme;


    if(dark_menu == 1 || dark_menu == '1' || dark_menu == true || dark_menu == 'true') {
      _siteHeaderMenu.setDarkTheme();
      setNavigationTheme(true);
    } else {
      _siteHeaderMenu.removeDarkTheme();
      setNavigationTheme(false);
    }
  });


  hero_swiper.on('init', function (swiper) {
    let slides = swiper.slides;
    let currentSlide = slides[swiper.activeIndex];
    let dark_menu = currentSlide.dataset.menuDarkTheme;


    if(dark_menu == 1 || dark_menu == '1' || dark_menu == true || dark_menu == 'true') {
      _siteHeaderMenu.setDarkTheme();
      setNavigationTheme(true);
    } else {
      _siteHeaderMenu.removeDarkTheme();
      setNavigationTheme(false);
    }
  });


  function setNavigationTheme(dark = true) {
    let thumb_menu = document.querySelector('.js-navigation-thumbs');

    if(dark) {
      thumb_menu.classList.add('is-dark-mode');
    } else {
      thumb_menu.classList.remove('is-dark-mode');
    }
  }

  // Process slider
  const psNavSwiper = new Swiper('.ps__nav-swiper', {
    spaceBetween: 10,
    slidesPerView: 8,
    watchSlidesProgress: true,
  });

  new Swiper('.ps__main-swiper', {
    loop: true,
    autoplay: {
      delay: 2500,
    },
    thumbs: {
      swiper: psNavSwiper,
    },
  });

  // Products tabs

  let prodTabsSliders = document.querySelectorAll('.prodtabs__nav-swiper');
  let prodTabsSlidersLength = prodTabsSliders.length;
  let prodtabsNavSwipers = new Array();

  prodTabsSliders.forEach(function (e, index) {
    prodtabsNavSwipers[index] = new Swiper('.prodtabs__nav-swiper', {
      loop: false,
      slidesPerView: 3,
      watchSlidesProgress: true,
      allowTouchMove: false,
    });

    let prodTabsMainSliders = document.querySelectorAll(
      '.prodtabs__main-swiper'
    );

    let swiperThumbs;

    if (prodTabsSlidersLength == 1) {
      swiperThumbs = prodtabsNavSwipers[index];
    } else {
      swiperThumbs = prodtabsNavSwipers[index][index];
    }

    new Swiper(prodTabsMainSliders[index], {
      loop: false,
      spaceBetween: 24,
      slidesPerView: 1,
      thumbs: {
        swiper: swiperThumbs,
      },
      hashNavigation: {
        watchState: true,
      },
      allowTouchMove: false,
      autoHeight: true,
    });
  });

  new Swiper('.prodtabs__products-swiper', {
    spaceBetween: 40,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        allowTouchMove: true,
        loop: false,
      },
      768: {
        slidesPerView: 2.2,
        allowTouchMove: true,
        loop: false,
      },
      1280: {
        slidesPerView: 3,
        allowTouchMove: false,
        loop: false,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  // Producers tabs

  let producersTabsSliders = document.querySelectorAll(
    '.producers-tabs__nav-swiper'
  );
  let producersTabsSlidersLength = producersTabsSliders.length;
  let producersTabsNavSwipers = new Array();

  producersTabsSliders.forEach(function (e, index) {
    producersTabsNavSwipers[index] = new Swiper('.producers-tabs__nav-swiper', {
      loop: false,
      slidesPerView: 3,
      breakpoints: {
        320: {
          slidesPerView: 1.3,
        },
        768: {
          slidesPerView: 2.3,
        },
        1024: {
          slidesPerView: 3,
          allowTouchMove: false,
          loop: false,
        },
      },
      watchSlidesProgress: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    let producersTabsMainSliders = document.querySelectorAll(
      '.producers-tabs__main-swiper'
    );

    let swiperThumbs;

    if (producersTabsSlidersLength == 1) {
      swiperThumbs = producersTabsNavSwipers[index];
    } else {
      swiperThumbs = producersTabsNavSwipers[index][index];
    }

    new Swiper(producersTabsMainSliders[index], {
      loop: false,
      spaceBetween: 24,
      slidesPerView: 1,
      thumbs: {
        swiper: swiperThumbs,
      },
      hashNavigation: {
        watchState: true,
      },
      allowTouchMove: false,
      autoHeight: true,
    });
  });

  // Modals
  let modals = document.querySelectorAll('[data-modal]');

  modals.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      const modal = document.getElementById(trigger.dataset.modal);
      modal.classList.add('open');

      const exits = modal.querySelectorAll('.modal-exit');
      exits.forEach(function (exit) {
        exit.addEventListener('click', function (event) {
          event.preventDefault();
          modal.classList.remove('open');

          const iframe = modal.getElementsByTagName('iframe')[0];
          if (typeof iframe != 'undefined' && iframe != null) {
            const url = iframe.getAttribute('src');
            iframe.setAttribute('src', '');
            iframe.setAttribute('src', url);
          }
        });
      });
    });
  });

  function shortText() {
    var elements = document.getElementsByClassName("show-more");
    var click_event = function () {
      var linkText = this.innerHTML.toUpperCase();
      if (linkText === "ROZWIŃ") {
        this.innerHTML = "Zwiń";
        this.previousElementSibling.classList.remove("hideContent");
        this.previousElementSibling.classList.add("showContent");
      } else {
        this.innerHTML = "Rozwiń";
        this.previousElementSibling.classList.remove("showContent");
        this.previousElementSibling.classList.add("hideContent");
      }
    };

    for (var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('click', click_event, false);
    }
  }

  shortText();

  // Accordion
  const accordionItems = document.querySelectorAll('.accordion__item');

  accordionItems.forEach(function (trigger) {
    const accordionHeader = trigger.querySelector('.accordion__header');

    accordionHeader.addEventListener('click', function (event) {
      event.preventDefault();
      trigger.classList.toggle('open');
    });
  });

  // Glightbox
  var lightbox = GLightbox();

  // Persons menu

  const personsMenuHeaders = document.querySelectorAll('.persons__menu h2');
  personsMenuHeaders.forEach(function (trigger) {
    const next = trigger.nextElementSibling;
    trigger.addEventListener('click', function () {
      next.classList.toggle('open');
    });
  });

  const personsMenus = document.querySelectorAll('.persons__menu ul');
  personsMenus.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      trigger.classList.remove('open');
    });
  });

  const categoryButtons = document.querySelectorAll('.category-article__link');
  categoryButtons.forEach((e) => {
    if (e.innerHTML.length > 99) {
      let short = e.innerHTML.substr(0, 56).concat('...');
      e.innerHTML = short;
    }
  });

  // Accordions
  const accordions = document.querySelectorAll('[data-accordion-button]');
  accordions.forEach((e) => {
    e.addEventListener('click', (event) => {
      event.preventDefault();
      e.parentElement.classList.toggle('is-active');
    });
  });

  const scrollBtns = document.querySelectorAll(".btn-top");

  scrollBtns.forEach((e) => {
    e.addEventListener("click", (event) => {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });

  const openSubMenus = document.querySelectorAll(".open-submenu");
  openSubMenus.forEach((e) => {
    e.addEventListener("click", (event) => {
      event.preventDefault();
      e.parentElement.classList.toggle("open");
    });

    e.addEventListener('mouseleave', (event) => {
      e.parentElement.classList.remove("open");
    });
  });

  const submenusParents = document.querySelectorAll(".js-header-menu .menu-item-has-children");
  submenusParents.forEach((e) => {
    e.addEventListener('mouseenter', (event) => {
      let windowWidth = window.innerWidth;
      let submenu = e.querySelector('.sub-menu');

      if (windowWidth < 992) {
        submenu.style.paddingTop = '0';
        return;
      }

      let header = document.querySelector('.js-site-header-nav');
      let headerHeight = header.offsetHeight;
      let elementPosition = e.getBoundingClientRect();
      let elementHeight = e.offsetHeight;
      let elementTop = elementPosition.top;
      submenu.style.paddingTop = (headerHeight - elementTop) + 'px';

    });
  })

  let sub_menus = document.querySelectorAll('.sub-menu');
  sub_menus.forEach(function (sub_menu) {
    // remove attr style
    sub_menu.removeAttribute('style');
  });

  const menuItems = document.querySelectorAll('.js-header-menu .menu-item');
  menuItems.forEach((e) => {
    let hr = document.createElement('hr');

    e.addEventListener('mouseenter', (event) => {
      let windowWidth = window.innerWidth;

      if (windowWidth < 992 || e.classList.contains('current_page_item') || e.parentElement.classList.contains('sub-menu')) {
        return;
      }

      let header = document.querySelector('.js-site-header-nav');
      let headerHeight = header.offsetHeight;
      let elementPosition = e.getBoundingClientRect();
      let elementTop = elementPosition.top;

      hr.style.top = (headerHeight - elementTop - 2) + 'px';
      e.appendChild(hr);
    });

    e.addEventListener('mouseleave', (event) => {
      if(e.querySelector('hr')) {
        e.removeChild(hr);
      }
    });

  });
});
